import styled from 'styled-components';

export const EditedTaxFieldInputContainer = styled.div<any>`
    display: inline-block;
    vertical-align: bottom;
    max-width: 10rem;

    & .MuiInputBase-root.MuiOutlinedInput-root.MuiInputBase-colorPrimary.MuiInputBase-adornedStart.MuiInputBase-adornedEnd:before {
        content: '';
        display: ${({ $isEdited }) => ($isEdited ? 'block' : 'none')};
        height: 100%;
        width: 0.375rem;
        background: #ebb000;
        position: absolute;
        left: 0;
        top: 0;
        border-top-left-radius: inherit;
        border-bottom-left-radius: inherit;
    }
`;
